
import {mergeMap,  tap } from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/



import { AppUtilityService } from '../../core/services/app-utility.service';
import { BehaviorSubject ,  Observable ,  of } from 'rxjs';
import { ConfigService } from '../../core/services/config.service';
import { DataStoreService } from '../../core/services/datastore.service';
import { HttpStatus } from '../../core/model/http-status-enum.model';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../core/services/lms-logger.service';
import { LocoDetail } from '../../core/model/loco-detail.model';
import { LocoTransfer } from '../../core/model/loco-transfer.model';
import { MessageDetails } from '../../core/model/message-details.model';
import { MessageHandlerService } from '../../core/services/message-handler.service';
import { PlanLocomotive } from './../../core/model/plan-locomotive.model';
import { PopupService } from '../../core/services/popup.service';
import { Router } from '@angular/router';
import { Tab } from '../../core/model/tab.model';
import { TabData } from '../../core/model/tab-data.model';
import { TerminalHandlingUpdateRequest } from '../../core/model/terminal-handling-update-request-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * Loco Data Service to get data for locomotives details.
 * @export
 * @class LocoDataService
 */
@Injectable()
export class LocoDataService {

  loadData: Observable<LocoDetail>; // Observable to get data from Web Service
  private loadDataBS: BehaviorSubject<LocoDetail>; // BehaviorSubject to get any change in Data
  private RESOURCE_URL = '/locomotives/'; // Rest URL to get Data
  private configData: any; // Get Config Service Data

  /**
   * Creates an instance of LocoDataService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {DataStoreService} dataStoreService
   * @param {LmsLoggerService} lmsLoggerService
   * @memberOf LocoDataService
   */
  constructor(private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService, private messageHandlerService: MessageHandlerService, private popupService: PopupService,
    private appUtilityService: AppUtilityService) {
    this.loadDataBS = <BehaviorSubject<LocoDetail>>new BehaviorSubject({});
    this.loadData = this.loadDataBS.asObservable();
    this.configData = this.configService.getConfigData();
  }


  /**
   * Reset Enter to Search
   * @memberOf LocoDataService
   */
  resetDefaultPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
   * Fetching Data from Rest Service Provided or loading data from dataStoreService if the data is already present.
   * @param {Tab} tab
   * @param {boolean} isRefresh
   * @memberOf LocoDataService
   */
  load(tab: Tab, fromOtherOperation?: boolean, messageText?: string) {
    this.resetDefaultPageMode();
    let locoData: LocoDetail;
    let foundInDataStore = false;
    if (tab && tab.tabSearchParameter) {
      if (tab.tabSearchParameter.searchText) {
        tab.tabSearchParameter.searchText = tab.tabSearchParameter.searchText.trim();
      } else {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if ('error' === tab.subTypeDetail[tab.subType.toLowerCase()].status) {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (!this.appUtilityService.isValidLocomotiveId(tab.tabSearchParameter.searchText)) {
        this.showErrorOnInvalidLocoSearch();
      } else {
        if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== 'refresh') {
          const tabData = this.dataStoreService.getValue(tab);
          if (tabData) {
            locoData = <LocoDetail>(tabData.data[tab.subType]);
            foundInDataStore = true;
            this.loadDataBS.next(locoData);
            this.lmsLoaderService.hideLoader();
          }
        } else {
          foundInDataStore = false;
        }

        if (!foundInDataStore) {
          this.dataSearch(tab, fromOtherOperation, messageText);
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.loadDataBS.next(null);
    }
  }

  /**
   * @memberof LocoDataService
   */
  private showErrorOnInvalidLocoSearch() {
    const lLocoDetail = <LocoDetail>({
      httpStatus: 400,
      errorMessage: this.configService.getConfigData().messages.invalidLocomotive
    });
    this.loadDataBS.next(lLocoDetail);
    this.lmsLoaderService.hideLoader();
    this.lmsLoggerService.logError('LocoDataService => load()',
      this.configService.getConfigData().messages.invalidLocomotive);
  }


  /**
   * @param {Tab} tab
   * @param {boolean} fromOtherOperation
   * @param {string} messageText
   * @memberof LocoDataService
   */
  private dataSearch(tab: Tab, fromOtherOperation: boolean, messageText: string) {
    this.lmsLoaderService.showLoader();
    const opr = 'INQU';
    const locoId = this.appUtilityService.formatLocomotiveId(tab.tabSearchParameter.searchText);
    this.lmsLoggerService.logInfo('LocoDataService=>load service call starts');
    this.http.get(
      `${this.configData.urls.API_URL}${this.RESOURCE_URL}${locoId}?opr=${opr}`
    ).pipe(
      tap(() => this.lmsLoggerService.logInfo('LocoDataService=>load service call ends'))
    )
      .subscribe(data => {
        this.subscribeData(tab, data, fromOtherOperation, messageText);
      },
      error => {
        this.errorOccuredWhileGettingData(error, fromOtherOperation, messageText);
      });

  }
  /**
   * @memberOf LocoDataService
   */
  cleanBehaviourSubject() {
    this.loadDataBS.next(null);
  }

  /**
   * @private
   * @param {*} error
   * @param {boolean} fromOtherOperation
   * @param {string} messageText
   * @memberof LocoDataService
   */
  private errorOccuredWhileGettingData(error: any, fromOtherOperation: boolean, messageText: string) {
    this.lmsLoaderService.hideLoader();
    const lLocoDetail = <LocoDetail>({
      httpStatus: error.status,
      errorMessage: fromOtherOperation ? messageText + ', but an error has occurred while refreshing the page.' : this.appUtilityService.getHttpErroMessage(error, false)
    });
    this.loadDataBS.next(lLocoDetail);
    this.lmsLoggerService.logError('LocoDataService => load()',
      this.appUtilityService.getHttpErroMessage(error, false));
  }

  /**
   * @param {Tab} tab
   * @param {*} data
   * @param {boolean} fromOtherOperation
   * @param {string} messageText
   * @memberof LocoDataService
   */
  private subscribeData(tab: Tab, data: any, fromOtherOperation: boolean, messageText: string) {
    if (data && data.priorityCode) {
      const pCode = parseInt(data.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.successfullLocoSearch(tab, data, fromOtherOperation, messageText);
      } else {
        this.lmsLoaderService.hideLoader();
        const lLocoDetail = <LocoDetail>({
          httpStatus: 400,
          errorMessage: fromOtherOperation ? messageText + ', but ' + data.messageText : data.messageText
        });
        this.loadDataBS.next(lLocoDetail);
        this.lmsLoggerService.logError('LocoDataService => load()',
          data.messageText);
      }
    }
  }

  /**
   * @private
   * @param {Tab} tab
   * @param {*} data
   * @param {boolean} fromOtherOperation
   * @param {string} messageText
   * @memberof LocoDataService
   */
  private successfullLocoSearch(tab: Tab, data: any, fromOtherOperation: boolean, messageText: string) {
    const lLocoDetail = <LocoDetail>(data.locoData);
    if (lLocoDetail.listOfNote && lLocoDetail.listOfNote.length > 0) {
      if (lLocoDetail.listOfNote.length > 3) {
        lLocoDetail.shownList = 3;
      } else {
        lLocoDetail.shownList = lLocoDetail.listOfNote.length;
      }
    }
    const tabData = <TabData>({
      id: tab.id,
      subType: tab.subType
    });
    tabData.data = tabData.data ? tabData.data : {};
    tabData.data[tab.subType] = lLocoDetail;
    lLocoDetail.refreshTime = data.refreshTime;
    lLocoDetail.httpStatus = HttpStatus.OK;
    lLocoDetail.tabId = tab.id;
    tab.subTypeDetail.data.message = '';
    tab.tabSearchParameter.searchText = this.appUtilityService.UIformatLocomotiveId(tab.tabSearchParameter.searchText);
    lLocoDetail.errorMessage = '';
    this.lmsLoaderService.hideLoader();
    this.dataStoreService.putValue(tab, tabData);
    this.loadDataBS.next(lLocoDetail);
    this.lmsLoggerService.logInfo('LocoDataService => load()',
      `Loco Data Fetch Successfull for ${JSON.stringify(tab)}`);
    if (fromOtherOperation) {
      this.messageHandlerService.handleMessage(<MessageDetails>({
        type: this.configData.message.type.client,
        level: this.configData.message.level.success,
        target: this.configData.message.target.page,
        message: messageText
      }));
    }
  }
  /**
   * Update Terminal handling Plan Service Call
   * @param {TerminalHandlingUpdateRequest} terminalHandlingUpdateRequest
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  updateThp(terminalHandlingUpdateRequest: TerminalHandlingUpdateRequest): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    const opr = 'UTHP';
    const wc = 'LWLD';
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>updateThp service call starts');
    return this.http.put<any>(`${apiUrl}/terminals/${terminalHandlingUpdateRequest.thpTerminal}/locomotives/thp?opr=${opr}&wc=${wc}`,
      JSON.stringify(terminalHandlingUpdateRequest), options).pipe(
        tap(() => this.lmsLoggerService.logInfo('LocoDataService=>updateThp service call ends'))
      );
  }

  /**
   * Bre Transfer Request Call
   * @param {Array<String>} locoList
   * @param {string} trainId
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  breTransferRequest(locoList: Array<String>, trainId: string): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>breTransferRequest service call starts');
    return this.http.put<any>(`${apiUrl}/trains/${trainId}/breparam?opr=INQU`,
      JSON.stringify(locoList), options).pipe(
        tap(() => this.lmsLoggerService.logInfo('LocoDataService=>breTransferRequest service call ends'))
      );
  }

  /**
   * Loco Transfer Service Call
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  transferLocomotive(locoTransfer: Array<LocoTransfer>, operation: string, windowCode: string): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>transferLocomotive service call starts');
    return this.http.put<any>(`${apiUrl}/locomotives?opr=${operation}&wc=${windowCode}`,
      JSON.stringify(locoTransfer), options).pipe(
        tap(() => this.lmsLoggerService.logInfo('LocoDataService=>transferLocomotive service call ends'))
      );
  }


  /**
   * Add Loco Service Call
   * @param {LocoDetail} locoDetails
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  addLocomotive(locoDetails: LocoDetail): Observable<Response> {
    const opr = 'INQU';
    const locoId = this.appUtilityService.formatLocomotiveId(locoDetails.locomotiveIdentifier);
    this.lmsLoggerService.logInfo('LocoDataService=>addLocomotive service call starts');
    return this.http.get(`${this.configData.urls.API_URL}${this.RESOURCE_URL}${locoId}?opr=${opr}`).pipe(mergeMap(response => {
      this.lmsLoggerService.logInfo('LocoDataService=>addLocomotive service call ends');
      const data = response;
      const pCode = parseInt(data['priorityCode'], 10);
      if (pCode >= 5 && pCode <= 9) {
        return this.getAddLocoResponse(locoDetails);
      } else {
        return of(null);
      }
    }));
  }

  /**
   * Retrieve add locomotive service call response.
   * @param {LocoDetail} locoDetails
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  getAddLocoResponse(locoDetails: LocoDetail): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>getAddLocoResponse service call starts');
    return this.http.post<any>(`${apiUrl}${this.RESOURCE_URL}?opr=EADD`, JSON.stringify(locoDetails), options).pipe(
      tap(() => this.lmsLoggerService.logInfo('LocoDataService=>getAddLocoResponse service call ends'))
    );
  }

  /**
   * Update Loco Service Call
   * @param {LocoDetail} locoDetails
   * @param {string} locoId
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  updateLocomotive(locoDetails: LocoDetail, locoId: string): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>updateLocomotive service call starts');
    return this.http.put<any>(`${apiUrl}${this.RESOURCE_URL}${locoId}?opr=UPDT`, JSON.stringify(locoDetails), options).pipe(
      tap(() => this.lmsLoggerService.logInfo('LocoDataService=>updateLocomotive service call ends'))
    );
  }

  /**
   * Delete Loco Service Call
   * @param {string} currentAssignment
   * @param {string} locoId
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  deleteExistingLocomotive(currentAssignment: string, locoId: string): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;    
    this.lmsLoggerService.logInfo('LocoDataService=>deleteExistingLocomotive service call starts');
    return this.http.delete<any>(`${apiUrl}${this.RESOURCE_URL}${locoId}?ca=${currentAssignment}&opr=DLET`).pipe(
      tap(() => this.lmsLoggerService.logInfo('LocoDataService=>deleteExistingLocomotive service call ends'))
    )
  }

  /**
   * submit plan locomotive request.
   * @param {string} planType
   * @param {PlanLocomotive} planLocomotive
   * @returns {Observable<Response>}
   * @memberOf LocoDataService
   */
  submitPlanLocomotive(planType: string, planLocomotive: PlanLocomotive): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('LocoDataService=>submitPlanLocomotive service call starts');
    return this.http.put<any>(`${apiUrl}${this.RESOURCE_URL}`,
      JSON.stringify(planLocomotive), options).pipe(
        tap(() => this.lmsLoggerService.logInfo('LocoDataService=>submitPlanLocomotive service call ends'))
      );
  }
}
